<template>
    <div>
      <div class="card">
        <div class="card-header">
            <ol class="breadcrumb breadcrumb-card-header pull-left">
                <li class="breadcrumb-item">
                    <a href="javascript:void(0);" @click="backParent">Survey</a>
                </li>
                <li class="breadcrumb-item active">
                    <span v-if="order.order_no === null">New</span>
                    <span v-else>
                        {{ order.order_no }}
                    </span>
                </li>
            </ol>
            <button type="button" class="btn btn-sm pull-right"  data-toggle="modal" data-target="#modalSaleOrderAttachment" data-backdrop="static" data-keyboard="false" >
                <i class="fa fa-paperclip" aria-hidden="true"></i> Attachment
            </button>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                      <label for="sale_date" class="col-sm-3 col-form-label text-left">Date</label>
                      <div class="col-sm-9">
                        <datetime v-model="order.order_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                      </div>
                  </div>
                  <!-- <div class="form-group row">
                      <label for="sale_due_date" class="col-sm-3 col-form-label text-left">Due Date</label>
                      <div class="col-sm-9">
                          <datetime v-model="order.order_due_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                      </div>
                  </div>
                  <div class="form-group row">
                    <label for="type_id" class="col-sm-3 col-form-label text-left">Price List</label>
                    <div class="col-sm-9">
                      <select class="form-control" v-model="order.price_id"  @change="getType">
                        <option v-for="p in priceListGroup" :key="p.id" :value="p.id">{{ p.name }}</option>
                      </select>
                    </div>
                  </div> -->
                  <div class="form-group row">
                    <label for="vendor_no" class="col-sm-3 col-form-label text-left">Branch</label>
                    <div class="col-sm-9">
                      <select v-model="order.branch_no" id="vendor_no" class="form-control" @change="getType">
                        <option value="" >-- Branch --</option>
                        <option v-for="v in branchList" :key="v.id" :value="v.branch_no">
                          {{ v.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                      <label for="salesman_id" class="col-sm-3 col-form-label text-left">Surveyor</label>
                      <div class="col-sm-9">
                          <select class="form-control" v-model="order.surveyor_id">
                              <option v-for="u in userList" :key="u.id" :value="u.id">{{ u.name }}</option>
                          </select>
                      </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label for="customer_no" class="col-sm-3 col-form-label text-left">Customer</label>
                    <div class="col-sm-9">
                      <button type="button" data-toggle="modal" data-target="#modalCustomerForm" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-primary">+</button>
                      <button type="button" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-primary" @click="getCustomerList">List</button>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="customer_no" class="col-sm-3 col-form-label text-left">Customer No</label>
                    <div class="col-sm-9">
                      <input type="text" v-model="order.customer_no" class="form-control" disabled="disabled" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="customer_name" class="col-sm-3 col-form-label text-left">Name</label>
                    <div class="col-sm-9">
                      <input type="text" v-model="order.customer.name" class="form-control" disabled="disabled" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="customer_phone" class="col-sm-3 col-form-label text-left">Phone</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="order.customer.phone"  disabled="disabled"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="customer_address" class="col-sm-3 col-form-label text-left">Address</label>
                    <div class="col-sm-9">
                      <textarea class="form-control" v-model="order.customer.address" rows="5" disabled="disabled"/>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                  <table class="table table-sm table-item table-hover">
                      <thead>
                          <th>Product No</th>
                          <th>Description</th>
                          <th>Qty</th>
                          <th>UoM</th>
                          <th>#</th>
                      </thead>
                      <tbody>
                          <tr v-for="(d, index) in salesDetail" :key="d.id" >
                            <td>
                              <p class="input-group">
                                <input type="text" class="form-control" v-model="d.product_no" disabled="disabled" />
                                <span class="input-group-btn ml-1">
                                  <button data-toggle="modal" data-target="#modalGetProduct" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm" @click="setIdDetail(index)"><i class="fa fa-search" aria-hidden="true"></i></button>
                                </span>
                              </p>
                            </td>
                            <td>{{ d.description }}</td>
                            <td><input type="text" v-model="d.qty" class="form-control" v-on:keyup="calcRow(d.id)"/></td>
                            <td>
                              <select v-model="d.uom_id" class="form-control" @change="calcRow(d.id)">
                                <option v-for="u in d.uomList" :value="u.id" :key="u.id">{{ u.name }}</option>
                              </select>
                            </td>
                            <!-- <td> -->
                              <!-- <input type="text" v-model="d.price" v-money="money" class="form-control" v-on:keyup="calcRowPrice(d.id)"/> -->
                            <!-- </td> -->
                            <!-- <td>{{ d.total | currency }}</td> -->
                            <td>
                              <!-- <button type="button" class="btn btn-info btn-sm" @click="editDetail(d.id)" data-toggle="modal" data-target="#modalSaleDetail" data-backdrop="static" data-keyboard="false">Edit</button> -->
                              <button type="button" class="btn btn-danger btn-sm" @click="removeDetail(index)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                                <a href='#' data-toggle="modal" data-target="#modalSaleDetail" data-backdrop="static" data-keyboard="false" style="color:blue; cursor: pointer" @click="addNewLine">
                                Add Line
                                </a>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                      </tbody>
                  </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <hr>
                <div class="mt-5">
                  <h5>Notes:</h5>
                  <wysiwyg v-model="order.survey_notes" />
                </div>
              </div>
            </div>
        </div>
        <div class="card-footer">
          <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
          <!-- <button type="button" @click="printSO" class="btn btn-sm btn-warning pull-left" v-show="order.order_no !== null"><i class="fa fa-print"></i> Print SO</button> -->
          <button type="button" @click="createOrder" class="btn btn-sm btn-success pull-right" v-show="order.order_no !== null"><i class="fa fa-handshake-o" aria-hidden="true"></i> Penawaran</button>
          <button type="button" @click="updateSales" class="btn btn-sm btn-primary pull-right" v-show="order.order_no !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
          <button type="button" @click="createSales" class="btn btn-sm btn-success pull-right" v-show="order.order_no == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
        </div>
      </div>
      <!-- <SalesDetailModal :idDetail="idDetail" :sales="order" @selectProduct="selectProduct" :amountDue="getTotal"/> -->
      <SaleSurveyModal @selectProduct="selectProduct" />
      <CustomerFormModal @createCustomer="createCustomer" />
      <CustomerListModal @selectCustomerList="selectCustomerList" />
      <SaleOrderAttachmentModal :order="order"/>
      <!-- <pre>{{ uomList }}</pre> -->
      <!-- <pre>{{ sales }}</pre> -->
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in order.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <!-- <pre>{{ idDetail }}</pre> -->
      <!-- <pre>{{ order }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import SaleSurveyModal from '@/components/sales/SaleSurveyModal.vue'
import CustomerFormModal from '@/components/customer/CustomerFormModal.vue'
import CustomerListModal from '@/components/customer/CustomerListModal.vue'
import SaleOrderAttachmentModal from '@/components/sales/SaleOrderAttachmentModal.vue'
import { saleOrderUrl, getHeader, productUrl, callPrintSoUrl } from '../../config'

export default {
  name: 'SaleOrderForm',
  props: ['order'],
  components: {
    SaleSurveyModal,
    CustomerFormModal,
    CustomerListModal,
    SaleOrderAttachmentModal
  },
  created () {
    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init(this.onBarcodeScanned)
    // this.getType()
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  data () {
    return {
      idDetail: null,
      detail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      salesTypeList: state => state.sales.salesTypeList,
      branchList: state => state.branches.branchList,
      productList: state => state.products.productListAll,
      uomList: state => state.uom.uomList,
      userList: state => state.users.userAll,
      taxList: state => state.taxes.taxList,
      priceListGroup: state => state.priceLists.priceListGroup
    }),
    salesDetail: function () {
      return this.order.details
    },
    getSubtotal: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        console.log(array[i].total)
        if (isNaN(array[i].total) === false) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    getTax: function () {
      var subtotal = this.getSubtotal
      var discount = parseFloat(this.order.discount.replace(/\./g, ''))
      var taxId = this.order.tax_id
      var taxAmount = 0
      var taxLis = this.taxList.find(d => d.id === taxId)
      if (taxLis) {
        if (taxLis.include === false) {
          taxAmount = (subtotal - discount) * (parseInt(taxLis.amount) / 100)
          return taxAmount.toString()
        } else {
          return '0'
        }
      } else {
        return '0'
      }
    },
    getTotal: function () {
      var subtotal = this.getSubtotal
      var discount = parseFloat(this.order.discount.replace(/\./g, ''))
      var subtotal2 = subtotal - discount
      var total = parseFloat(subtotal2) + parseFloat(this.order.tax)
      return total.toString()
    }
  },
  methods: {
    printSO: function () {
      window.open(callPrintSoUrl + '/' + this.order.id, '_blank')
    },
    createOrder: function () {
      this.order.subtotal = this.getSubtotal
      this.order.total = this.getTotal
      this.order.status = 'order'
      axios.put(saleOrderUrl + '/' + this.order.id, this.order, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Sale',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response.data.message + '</pre>',
            'error'
          )
        })
    },
    setTax: function () {
      var subtotal = this.getSubtotal
      var discount = parseFloat(this.order.discount.replace(/\./g, ''))
      var taxId = this.order.tax_id
      var taxLis = this.taxList.find(d => d.id === taxId)
      var taxAmount = 0
      if (taxLis.include === false) {
        taxAmount = (subtotal - discount) * (parseInt(taxLis.amount) / 100)
        this.order.tax = taxAmount.toString()
      } else {
        this.order.tax = '0'
      }
    },
    calcRowPrice: function (id) {
      var detail = this.order.details.find(d => d.id === id)
      detail.total = parseFloat(detail.qty) * parseFloat(detail.price.replace(/\./g, ''))
    },
    calcRow: function (id) {
      var detail = this.order.details.find(d => d.id === id)
      var priceRatio = detail.uomList.find(i => i.id === detail.uom_id)
      detail.price = priceRatio.price.toString()
      detail.total = parseFloat(detail.qty) * parseFloat(detail.price)
    },
    setIdDetail: function (id) {
      this.idDetail = id
      this.getType()
    },
    getType: function () {
      var obj = {
        priceID: 1,
        branch: this.order.branch_no,
        warehouse: null
      }
      this.$store.dispatch('getProductByPriceList', obj)
    },
    onBarcodeScanned (barcode) {
      var obj = {
        barcode: barcode
      }
      console.log(barcode)
      axios.post(productUrl + '/scan/barcode', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          const product = response.data.data
          var productDetail = this.order.details.find(d => d.product_no === product.product_no)
          if (productDetail) {
            productDetail.qty = parseInt(productDetail.qty) + 1
            productDetail.total = parseInt(productDetail.qty) * parseFloat(productDetail.price)
          } else {
            // const price = product.productGet.uomList.find(d => d.category_id === 3)
            var obj = {
              id: Math.floor(Math.random() * (99999999 - 66666666) + 66666666),
              product_no: product.product_no,
              product: product.productGet.product_name,
              description: product.productGet.product_description,
              qty: 1,
              uom_id: product.productGet.uom_id,
              price: product.price,
              discount: '0',
              total: product.price,
              state: null,
              uomList: product.productGet.uomList
            }
            this.order.details.push(obj)
          }
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    getCustomerList: function () {
      this.$store.dispatch('getCustomerList')
    },
    createCustomer: function (customer) {
      console.log(customer)
      this.order.customer_no = customer.customer_no
    },
    detailClear: function () {
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        // array[i].edit = false
      }
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    updateSales () {
      this.order.subtotal = this.getSubtotal
      this.order.total = this.getTotal
      this.order.status = 'survey'
      axios.put(saleOrderUrl + '/' + this.order.id, this.order, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Sale',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response.data.message + '</pre>',
            'error'
          )
        })
    },
    createSales () {
      this.order.status = 'order'
      this.order.total = this.getTotal
      this.order.status = 'survey'
      axios.post(saleOrderUrl, this.order, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response.data)
          this.$swal(
            'Error!!',
            '<pre>' + error.response.data.message + '</pre>',
            'error'
          )
        })
    },
    addNewLine: function () {
      // this.$store.dispatch('getProductList')
      // var newID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      this.order.details.push({
        order_no: null,
        order_null: null,
        branch_no: null,
        product_no: null,
        description: null,
        qty: null,
        serial_number: null,
        uom_id: null,
        price: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        state: 'create',
        edit: false,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: null,
          active: null
        }]
      })
      this.state = 'create'
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    editDetail: function (id) {
      // var p = this.sales.details.find(d => d.id === id)
      this.idDetail = id
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    removeDetail: function (index) {
      var detail = this.order.details[index]
      if (detail.state === 'create') {
        this.order.details.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(saleOrderUrl + '/detail/' + detail.id, { headers: getHeader() })
              .then(response => {
                this.order.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    selectProduct: function (value) {
      console.log(value)
      console.log(this.idDetail)
      var detail = this.order.details[this.idDetail]
      console.log('detail')
      console.log(detail)
      detail.order_no = null
      detail.branch_no = this.order.branch_no
      detail.product_no = value.product_no
      detail.description = value.product_name
      detail.qty = 1
      detail.serial_number = null
      detail.uom_id = value.uom_id
      detail.price = value.price
      detail.tax_id = null
      detail.tax = null
      detail.discount = 0
      detail.total = value.price
      detail.state = 'create'
      detail.uomList = value.uomList
    },
    selectCustomerList: function (customer) {
      this.order.customer_no = customer.customer_no
      this.order.customer = customer
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
